import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { weekForSchedule } from "../../assets/const";
import Loader from '../Loader';

function ScheduleTable({ schedule, loading, onCellDoubleCLick }) {

    const [listOfClasses, setListOfClasses] = useState([]);
    const [daysOfWeek, setDaysOfWeek] = useState([]);

    useEffect(() => {
        const classes = Array.from(new Set(schedule.map(item => item.groupname)));
        classes.sort((a, b) => {
            const aElective = a.toLowerCase().includes('электив');
            const bElective = b.toLowerCase().includes('электив');
            if (aElective && !bElective) return 1;
            if (!aElective && bElective) return -1;
            return 0;
        });
        setListOfClasses(classes);

        const allDays = schedule.map(item => item.day_of_week);
        const days = Array.from(new Set(allDays)).sort((a, b) => a - b);
        setDaysOfWeek(days);
    }, [schedule]);

    const getTimesForDay = (dayOfWeek) => {
        const times = Array.from(new Set(
            schedule
                .filter(item => item.day_of_week === dayOfWeek)
                .map(item => item.starttime)
        ));

        const isExtra = (time) =>
            schedule.some(
                item =>
                    item.starttime === time &&
                    item.day_of_week === dayOfWeek &&
                    item.periodname?.toLowerCase().includes('внеурочн')
            );

        return times.sort((a, b) => {
            const aExtra = isExtra(a);
            const bExtra = isExtra(b);
            if (aExtra && !bExtra) return 1;
            if (!aExtra && bExtra) return -1;
            return 0;
        });
    };

    const formatLessonTime = (lesson) =>
        lesson ? `${lesson.periodname}` : '';


    const onDoubleClick = (cellData) => () => {
        if (onCellDoubleCLick) onCellDoubleCLick(cellData);
    };

    return (
        <div className={styles.wrapper}>
            {loading
                ? <Loader />
                : schedule.length > 0
                    ? <div className={styles.scheduleTable} id="scheduleTable">
                        <table>
                            <thead>
                                <tr>
                                    <th colSpan={2}>Период</th>
                                    {listOfClasses.map((className, index) => (
                                        <React.Fragment key={index}>
                                            <th rowSpan={2}>{className}</th>
                                            <th rowSpan={2} style={{ maxWidth: '60px', width: '60px' }}>№ каб.</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                                <tr>
                                    <th>День недели</th>
                                    <th>Время</th>
                                </tr>
                            </thead>
                            <tbody>
                                {daysOfWeek.map((dayOfWeek, dayIndex) => {
                                    const timesForDay = getTimesForDay(dayOfWeek);
                                    console.log('timesForDay::: ', timesForDay);
                                    const dayName = weekForSchedule.find(item => item.value === dayOfWeek)?.name || '';

                                    return timesForDay.map((time, timeIndex) => {
                                        const lessonsForTime = schedule.filter(
                                            item => item.starttime === time && item.day_of_week === dayOfWeek
                                        );
                                        const isFirst = timeIndex === 0;

                                        return (
                                            <tr key={`${dayIndex}-${timeIndex}`}>
                                                {isFirst && (
                                                    <td rowSpan={timesForDay.length} className={styles.dayCell}>
                                                        {dayName}
                                                    </td>
                                                )}
                                                <td className={styles.timeCell}>
                                                    {formatLessonTime(lessonsForTime[0])}
                                                    {console.log('formatLessonTime(lessonsForTime[0])::: ', formatLessonTime(lessonsForTime[0]))}
                                                </td>
                                                {listOfClasses.map((className, classIndex) => {
                                                    const lessonsForClass = lessonsForTime.filter(
                                                        item => item.groupname === className
                                                    );
                                                    const lessonNames = lessonsForClass.map(item => item.coursename).filter(Boolean);
                                                    const lessonRooms = lessonsForClass.map(item => item.roomname).filter(Boolean);

                                                    return (
                                                        <React.Fragment key={classIndex}>
                                                            <td onDoubleClick={onDoubleClick(lessonsForClass)}>
                                                                {lessonNames.join(' / ')}
                                                            </td>
                                                            <td>
                                                                {lessonRooms.join(' / ')}
                                                            </td>
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    });
                                })}
                            </tbody>
                        </table>
                    </div>
                    : <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '200px', color: '#1671EF' }}>
                        НЕТ ДАННЫХ
                    </div>
            }
        </div>
    );
}

export default ScheduleTable;
